<template>
  <div class="default-layout">
    <div
      id="viewport"
      class="w-100 relative"
    >
      <auth />
    </div>
  </div>
</template>
<script>
    import Auth from '../components/Authentication.vue';
    export default {
        components: {
            Auth
        },
    }
</script>
